import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveCreditType } from "@/generated/models/ApiWaveCreditType";
import WaveRatingRep from "./WaveRatingRep";
const CREDIT_TYPE_LABELS: Record<ApiWaveCreditType, string> = {
  [ApiWaveCreditType.Tdh]: "TDH",
  [ApiWaveCreditType.Rep]: "REP"
};
interface WaveRatingProps {
  readonly wave: ApiWave;
}
export default function WaveRating(t0) {
  const $ = _c(8);
  const {
    wave
  } = t0;
  const creditType = wave.voting.credit_type;
  const t1 = CREDIT_TYPE_LABELS[creditType];
  let t2;
  if ($[0] !== t1) {
    t2 = <span className="tw-font-medium tw-text-iron-200 tw-text-sm">{t1}</span>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== creditType || $[3] !== wave) {
    t3 = creditType === ApiWaveCreditType.Rep && <div className="tw-ml-1.5"><WaveRatingRep wave={wave} /></div>;
    $[2] = creditType;
    $[3] = wave;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="tw-flex tw-items-center tw-gap-x-1.5"><div className="tw-flex tw-items-center">{t2}{t3}</div></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}